module.exports = __webpack_public_path__ + "img/isfj.82d24c30.png";